import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import dayjs from "dayjs"
import { z } from "zod"

import { auditLogQueryOptions } from "@/features/audit-logs/queries"

const AuditLogsSearchSchema = z.object({
  page: z.coerce.number().catch(1),
  search: z.coerce.string().optional().catch(undefined),
  startDate: z.string().catch(dayjs().subtract(1, "month").toISOString()),
  endDate: z.string().catch(dayjs().toISOString()),
  resourceType: z.coerce.string().optional().catch(undefined),
  facility: z.coerce.string().optional().catch(undefined),
  action: z.array(z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)])).optional(),
})

export const Route = createFileRoute("/_app/system/audit-logs/")({
  validateSearch: (search: SearchSchemaInput) =>
    AuditLogsSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    return context.queryClient.ensureQueryData(
      auditLogQueryOptions({
        params: {
          query: deps,
        },
      })
    )
  },
})
